import React, { FC, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "i18n";
import { Spinner } from "component-library";
import Layout from "../../../../../components/layout/Layout";
import { StepTracking } from "../../../../../components/StepTracking";
import { JOINING_APP_ROUTES } from "../../../../../config/common";
import { useApplication } from "../../../../../context/ApplicationContext";

interface Props {
  loading?: boolean;
}

const graduatesSteps = [
  JOINING_APP_ROUTES.GRADUATE.ABOUT_YOU,
  JOINING_APP_ROUTES.GRADUATE.DETAILS,
  JOINING_APP_ROUTES.GRADUATE.REVIEW,
  JOINING_APP_ROUTES.GRADUATE.SUBSCRIPTION,
  JOINING_APP_ROUTES.GRADUATE.CHECKOUT_JOINING,
];

const PageTrackingLayoutWrapper: FC<Props> = ({ children, loading }) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { onlineApplicationId } = useApplication();
  const navigate = useNavigate();
  const stepNumber = graduatesSteps.indexOf(pathname);

  useEffect(() => {
    if (!onlineApplicationId) {
      // should not be here if they're not logged in/started a new application
      navigate(JOINING_APP_ROUTES.GRADUATE.START_APP);
    }
  }, [onlineApplicationId]);

  return (
    <Layout removePadding>
      <StepTracking
        stepNumber={stepNumber}
        updateStepNumber={(stepNumber) => navigate(graduatesSteps[stepNumber])}
        stepTrackingItems={[
          { label: t("joining:graduate.aboutYou.page.title") },
          { label: t("joining:graduate.details.page.title") },
          { label: t("joining:graduate.review.page.title") },
          { label: t("joining:graduate.subscription.page.title") },
          { label: t("joining:graduate.checkout.page.title") },
        ]}
      />
      {loading ? <Spinner inline /> : children}
    </Layout>
  );
};

export default PageTrackingLayoutWrapper;
